import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Image from "material-ui-image";

const colortheme2 = createMuiTheme({
    palette: {
        primary: { main: "#f52d0a", contrastText: "#f52d0a" },
        secondary: { main: "#ffffff", contrastText: "#ffffff" }
    }
});

const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
});


class SaveTow extends Component {

    state = {
        age: '',
        name: 'hai',
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {

        return (
          <div id="top1"  style={{ backgroundColor:'#f7f5f2'  }}>
                <Grid container spacing={24}  >
        
          
      
          <Grid   item xs={12} sm={12}  md={6}  lg={8} xl={8} >
          
           
            <div  style = { { backgroundPosition:'center',    backgroundSize:'cover',  backgroundRepeat:'no-repeat',  marginLeft:20,  paddingTop:50, }}  >
    
      
                                
                                            <Typography variant="h4" gutterBottom  color="black" align="left">
                                            A Simple Question:
                                            </Typography>
                                            <Typography variant="h4" gutterBottom  color="black" align="left">
                                            What would you do if you see your vehicle is being towed?
                                            </Typography>
                                   
    
       
                                        <Typography  color ='red'  align="left">
                                            _____________________________________________
                                        </Typography>
       
       
                                        <Typography variant="h5"    style={{  color:'black'}}  align="left">
                                            Would you try to stop the tow? Of course!
                                        </Typography>
        
        
                                        <Typography variant="h5" gutterBottom  style={{color:'black'}} align="left">
                                            Why?
                                        </Typography>

                                        <Typography variant="h5" gutterBottom  style={{color:'black'}} align="left">
                                                Save time?
                                        </Typography>
                                        <Typography variant="h5" gutterBottom style={{color:'black'}} align="left">
                                                Save money?
                                        </Typography>
                                            <Typography variant="h5" gutterBottom  style={{color:'black'}} align="left">
                                                Prevent possible damage to your vehicle?
                                        </Typography>
                                            <Typography variant="h5" gutterBottom  style={{color:'black'}} align="left">
                                                Avoid any insurance hike?
                                        </Typography>
                                            <Typography variant="h5" gutterBottom style={{color:'black'}} align="left">
                                                Save the environment?
                                        </Typography>
                                        <Typography variant="h4" gutterBottom  style={{color: '#1212F3'}}   align="left">
                                            Now you can stop the tow!
                                        </Typography>
                                        <Typography variant="h4" gutterBottom  style={{color: '#1212F3'}}   align="left">
                                           We will notify you before your vehicle is towed!
                                        </Typography>
                                        
    
        
    
                                        </div>
                                  </Grid>
          
                                <Grid    item xs={12} sm={12}  md={6}  lg={4} xl={4}    >
                                  <div  style={{ marginRight:10, marginLeft:10, marginTop:10, marginBotton:10, height:'80%', width:'80%'}}>
                                    <Image
                                src="/static/images/IMG_3629_B.JPG"
                                  style={
                                  {
                                      flex: 1,
                                      resizeMode: 'contain',
                                     
                                
                                  }
                                }
                                  />
                                  
                                  </div>
                                  
                                  </Grid>
               
      
    
        </Grid>
        </div>
      
          


    );
    }
}

SaveTow.propTypes = {
    classes: PropTypes.object.isRequired,
};
//export default BiomassView;
export default withStyles(styles)(SaveTow);